import { Injectable } from '@angular/core';
import customerJson from '../assets/config/customer.json';

@Injectable()
export class Globals {
  username: string = 'undefined';
  userrole: string = 'undefined';
  rolesAndPermissions: boolean = false;
  fullname: string = 'undefined';
  messages: number = 0;
  autofillSendData: boolean = true;
  customerJson = customerJson;
  clientId: string = null;

  // Timeout
  // Idle-bugg: Make sure these values match with those in app.module.ts
  // for an hour idle: 3600 timeout: 30 ping: 240
  //idle: number = 540;
  //timeout: number = 30;
  //ping: number = 240;
  idle: number = this.customerJson.settings.timeout.idle;
  timeout: number = this.customerJson.settings.timeout.timeout;
  ping: number = this.customerJson.settings.timeout.ping;
}